import { SkeletonChartContainer, SkeletonChartTitle, SkeletonChart } from './Skeleton.styles';

interface SkeletonChartLoaderProps {
  variant?: 'pie' | 'doughnut';
}

export const SkeletonChartLoader = ({ variant = 'pie' }: SkeletonChartLoaderProps) => {
  return (
    <SkeletonChartContainer>
      <SkeletonChartTitle variant="text" width="70%" height={20} />
      {variant === 'pie' ? (
        <SkeletonChart variant="circular" width={400} height={400} />
      ) : (
        <SkeletonChart
          variant="rectangular"
          width="100%"
          height={400}
          sx={{ borderRadius: '4px' }}
        />
      )}
    </SkeletonChartContainer>
  );
};